import React, { Component, Fragment } from 'react';
import { TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export default class NumberCuit extends Component {
    constructor(props) {
        super(props);



        this.state = {
            errorText: '',
            error: props.error,
            initial: true,
            defaultValue: this.props.defaultValue,
            focus: false,
            tipo: ["27", "20", "23", "24", "30"],
            validation: [5, 4, 3, 2, 7, 6, 5, 4, 3, 2],

        };
        this.ultimoDigito = 0

        this.handleChange = this.handleChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }
    UNSAFE_componentWillReceiveProps(next_props) {
        this.setState({ error: next_props.error });
    }

    clearNumber = (value = '') => {
        return value.replace(/\D+/g, '');
    }

    handleChange = (event) => {

        let suma = 0
        let value = event.target.value;

        if (this.props.maxLength !== null) {
            const clearValue = this.clearNumber(value);
            value = clearValue.slice(0, this.props.maxLength);

        }

        this.setState({ defaultValue: value });

        if (value === '') {
            this.setState({ errorText: this.props.placeholder, error: true });
            this.ultimoDigito = 0
        } else {
            if (value.match('^[0-9]*$')) {

                if (this.props.minLength !== null && value.length < this.props.minLength) {
                    this.setState({ errorText: 'Mínimo ' + this.props.minLength + ' números', error: true })

                } else {

                    if (this.state.tipo.includes(value.slice(0, 2))) {

                        this.setState({ errorText: 'Máximo ' + this.props.maxLength + ' números', error: true })

                        let valoraValidar = value.slice(0, 10)

                        this.state.validation.forEach((element, i) => {

                            suma += valoraValidar[i] * element
                        });

                        let resto = (suma % 11)
                        //console.log("[CUIT VALIDATION] resto",resto);

                        // El ultimo digito tiene que ser lo que le falte a la suma para llegar al proximo multiplo de 11.
                        // en caso de ser una division exacta (sin resto), no faltara nada.
                        // por ende seteara 0 como ultimoDigito calculado.
                        this.ultimoDigito = (resto !== 0) ? (11 - resto) : resto;
                        // console.log("[CUIT VALIDATION] ultimo digito calculado", this.ultimoDigito);
                        // console.log("[CUIT VALIDATION] value ultimo digito", value[value.length - 1]);

                        if (value.length > 10) {
                            if (this.props.maxLength !== null && value.length !== this.props.maxLength) {

                                this.setState({ errorText: 'Máximo ' + this.props.maxLength + ' números', error: true })
                            } else {

                                if (value[value.length - 1] == this.ultimoDigito) {
                                    this.setState({ errorText: '', error: false })
                                } else {
                                    this.setState({ errorText: 'Cuit/Cuil inválido', error: true })
                                    this.ultimoDigito = 0;
                                }
                            }
                        } else {
                            this.setState({ errorText: 'Máximo ' + this.props.maxLength + ' números', error: true })
                        }

                    } else {
                        this.setState({ errorText: 'Cuit/Cuil inválido ', error: true })
                        this.ultimoDigito = 0;
                    }
                }
            } else {
                this.setState({ defaultValue: '', errorText: 'Sólo números', error: true })
                this.ultimoDigito = 0;
            }
        }
    }

    onBlur() { setTimeout(() => { if (this.state.focus) { this.setState({ focus: false }) } }, 0) }
    onFocus() { if (!this.state.focus) { this.setState({ focus: true }) } }

    render() {
        const OnFocusHideFixedElements = withStyles({
            "@global": {
                "body .headroom": { '@media (max-width: 960px)': { transform: "translate3d(0px, -100%, 0px)!important" } }
            }
        })(() => null);
        return (
            <Fragment>
                {this.state.focus && <OnFocusHideFixedElements />}
                <TextField
                    size="small"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    className={`InputForm ${this.props.classNameCustom}`}
                    variant="outlined"
                    error={this.state.error}
                    id={this.props.id}
                    label={this.props.label}
                    placeholder={this.props.placeholder}
                    helperText={this.state.errorText}
                    onChange={this.handleChange}
                    value={this.state.defaultValue}
                    name={this.props.name}
                    disabled={this.props.disabled}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                />
            </Fragment>
        );
    };
};
